// extracted by mini-css-extract-plugin
export var root = "Z7TX";
export var rootContainer = "i1ZR";
export var rootIcon = "QKdQ";
export var rootIconLoading = "U7DR";
export var rootNotFound = "-CkY";
export var rootSearching = "NzsD";